import i18n from "../../../language/i18n";

const RightsReserved = () => {
  return (
    <div className="rr-wrap">
      <div>
        <p className="rr-text">
          {i18n.t("all_rights_reserved_text")}
        </p>
      </div>
      <div>
        <p className="rr-link">
          <a href="https://www.catchupper.com/privacy" target="_blank" rel="noopener noreferrer">
            {i18n.t("privacy_policy")}
          </a>
        </p>
      </div>
    </div>
  );
};

export default RightsReserved;
